<ion-header class="ion-no-border">
</ion-header>

<ion-content>
  <div class="header-content width-100">
    <div class="header-title d-flex width-100">
      <h3>{{ title }}</h3>
    </div>
  </div>
  <div class="header-body width-100">
     <p>{{ message }}</p>
   </div>
</ion-content>
<ion-footer>
  <div class="buttons width-100">
    <button class="btn-ok-medium" shape="round" (click)="close()">Não</button>
    <button class="btn-ok-medium" shape="round" (click)="save()">Sim</button>
  </div>

</ion-footer>
